module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [(_vm.storeError) ? _c('div', {
    staticClass: "card card-inverse card-warning"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n            Warning\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n            " + _vm._s(_vm.storeError) + "\n          ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card p-4"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('form', {
    on: {
      "submit": _vm.login
    }
  }, [_c('h1', [_vm._v("Login")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Sign In to your account")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Username"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-4"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.recaptchaStorageKey) ? _c('div', {
    staticClass: "input-group mb-4"
  }, [_c('VueRecaptcha', {
    ref: "recaptcha",
    attrs: {
      "size": "normal",
      "sitekey": _vm.recaptchaStorageKey,
      "load-recaptcha-script": true
    },
    on: {
      "verify": _vm.onCaptchaVerified,
      "expired": _vm.onCaptchaExpired
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('button', {
    staticClass: "btn btn-primary px-4 login-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("\n                    Login\n                    "), (_vm.loading) ? _c('span', {
    staticClass: "btn-loader"
  }) : _vm._e()])])])])]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), (_vm.errors) ? _c('div', {
    staticClass: "card card-inverse card-danger"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n            Errors\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.errors)
    }
  })])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-lock"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-4"
  }, [_c('a', {
    attrs: {
      "href": "/#/password/reset"
    }
  }, [_vm._v("Forgot Password")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-inverse card-primary py-5 d-md-down-none",
    staticStyle: {
      "width": "44%"
    }
  }, [_c('div', {
    staticClass: "card-block text-center"
  }, [_c('div', [_c('h2', [_vm._v("Sign up")]), _vm._v(" "), _c('p', [_vm._v("Admin dashboard for the Ellen G. White Estate services.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-961e19dc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/unauthorizedPages/Login.vue
// module id = 969
// module chunks = 0